import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'

const MyLibraryAddedToPrivateLibrary = props => {

	const library_type = props.library_type === 'school' ? localize('my_library_school_library') : localize('my_library_district_library')

	return (
		<Confirm
			btOne={localize('my_library_added_to_private_library_button_1')}
			btTwo={localize('my_library_added_to_private_library_button_2')}
			alertMessage={localize('my_library_added_to_private_library_message_part_1') + ' ' + library_type +
                localize('my_library_added_to_private_library_message_part_2') + ' ' + library_type + ' ' + localize('my_library_added_to_private_library_message_part_3')}
			actionButtonType={0}
			actionOne={() => {
				props.actions.visitPrivateLibrary(props.library_uid)
			}}
			actionTwo={props.actions.closeAddedLessonToPrivateLibrary}
			closeAction={props.actions.closeAddedLessonToPrivateLibrary}
		/>
	)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		visitPrivateLibrary: myLibraryActions.visitPrivateLibrary,
		closeAddedLessonToPrivateLibrary: myLibraryActions.closeAddedLessonToPrivateLibrary,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibraryAddedToPrivateLibrary)
